import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import {
  useEntityRecordMatcher,
  UseEntityRecordMatcherReturn,
} from '../../../../hooks/use-entity-record-matcher';
import { MaskConfig } from '../types';

type Props = {
  mask: MaskConfig;
};

export type OverlayTemplate<TData> = UseEntityRecordMatcherReturn<TData>;

export const useOverlayTemplate = <TData>({
  mask,
}: Props): OverlayTemplate<TData> => {
  const sourceEntity = mask?.template?.entity as Entities;
  const targetEntity = mask?.entity as Entities;
  const sourceRecordIds = mask?.template?.ids ?? ([] as string[]);

  const skip =
    !targetEntity ||
    !sourceEntity ||
    !sourceRecordIds ||
    !(sourceEntity in Entities);

  return useEntityRecordMatcher<TData>({
    sourceEntity,
    sourceRecordIds,
    targetEntity,
    options: {
      skip,
    },
  });
};
